const update_sql2 = [
    `drop table if exists t_config;`,
    `create table t_config(key PRIMARY KEY,val,utime,ctime);`,
];
export default update_sql2;
